import {useMutation, useQueryClient} from '@tanstack/react-query'

import {contractTypeKeys} from '../contract-type/keys'
import {createDealer, updateDealer, linkDealerToContractType, unlinkDealerFromContractType} from './api'
import {dealerKeys} from './keys'
import {DealerRequest, DealerResponse} from './types'

export const useCreateDealer = () => {
  const queryClient = useQueryClient()
  return useMutation<DealerResponse, unknown, DealerRequest>({
    mutationFn: createDealer,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: dealerKeys.lists()})
    },
  })
}

export const useUpdateDealer = () => {
  const queryClient = useQueryClient()
  return useMutation<DealerResponse, unknown, {id: string; body: DealerRequest}>({
    mutationFn: ({id, body}) => updateDealer(id, body),
    onSuccess: (_, {id}) => {
      queryClient.invalidateQueries({queryKey: dealerKeys.detail(id)})
      queryClient.invalidateQueries({queryKey: dealerKeys.lists()})
    },
  })
}

export const useLinkDealerToContractType = () => {
  const queryClient = useQueryClient()
  return useMutation<void, unknown, {dealerId: string; contractTypeId: string}>({
    mutationFn: ({dealerId, contractTypeId}) => linkDealerToContractType(dealerId, contractTypeId),
    onSuccess: (_, {dealerId, contractTypeId}) => {
      queryClient.invalidateQueries({queryKey: dealerKeys.detail(dealerId)})
      queryClient.invalidateQueries({queryKey: dealerKeys.lists()})
      queryClient.invalidateQueries({queryKey: contractTypeKeys.detail(contractTypeId)})
    },
  })
}

export const useUnlinkDealerFromContractType = () => {
  const queryClient = useQueryClient()
  return useMutation<void, unknown, {dealerId: string; contractTypeId: string}>({
    mutationFn: ({dealerId, contractTypeId}) => unlinkDealerFromContractType(dealerId, contractTypeId),
    onSuccess: (_, {dealerId, contractTypeId}) => {
      queryClient.invalidateQueries({queryKey: dealerKeys.detail(dealerId)})
      queryClient.invalidateQueries({queryKey: dealerKeys.lists()})
      queryClient.invalidateQueries({queryKey: contractTypeKeys.detail(contractTypeId)})
    },
  })
}
